/* global $ */
import 'babel-polyfill';
import tippy from 'tippy.js';

/**
 * Handle all functionality for tracker grid CPT and module.
 */
const trackerGrid = () => {
  /**
   * Get all potential grids and assign functionality.
   */
  const $grids = $('.tracking-grid');
  $grids.each(function() {
    const $this = this;
    const $toggle = $('.tracking-grid-toggle__switch input', $this);
    const $display = $('.tracking-grid-display', $this);
    const $gridItems = $('.tracking-grid-item__trigger', $this);

    /* Tooltip template */
    /* Prevent arbitrary html insertion */
    const tooltipContent = (ref) => {
      const elem = $('.tracking-grid-item__expand', $(ref).parent());
      const title = $(
        '.tracking-grid-item__expand__inner__title__text',
        elem,
      ).text();
      const pos = $(
        '.tracking-grid-item__expand__inner__title__party',
        elem,
      ).text();
      const caption = $('.caption', elem).text();
      const link = $('.link', elem);

      const template = `
      <div class="tracking-grid-item__tooltip">
        <div class="tracking-grid-item__tooltip__title">
          <h4>
            ${
              title
                ? `<span class="tracking-grid-item__tooltip__title__text">${title}</span>`
                : ''
            }
            ${
              pos
                ? `<span class="tracking-grid-item__tooltip__title__party">${pos}</span>`
                : ''
            }
          </h4>
        </div>
        ${caption ? `<p class="caption">${caption}</p>` : ''}
        ${
          link.attr('href')
            ? `<a class="link link--nopsuedo link--teal" href="${link.attr(
                'href',
              )}" target="${link.attr('target')}" rel="${link.attr(
                'rel',
              )}">${link.text()}</a>`
            : ''
        }
      </div>
      `;

      return template;
    };

    /**
     * Handle Tooltips.
     * @link https://atomiks.github.io/tippyjs/v6/constructor/;
     *
     * Tippy expects an array of elements.
     * Assigned to defined instance var to allow disable/enable.
     */
    const tooltipInstances = tippy($gridItems.toArray(), {
      content(reference) {
        return tooltipContent(reference);
      },
      allowHTML: true,
      animation: 'customFade',
      interactive: true,
      arrow: false,
    });

    /**
     * Helper to test if is mobile state.
     */
    const bpTest = () =>
      $('.tracking-grid-toggle', $this)
        .first()
        .is(':visible');

    /**
     * Disable all tippys if below grid bp.
     * @link https://atomiks.github.io/tippyjs/v6/methods/#disable;
     *
     * Test if toggle is visible & if layout is grid.
     * Call immediately and on all reflows.
     */
    const disableTooltips = () => {
      for (let i = 0; i < tooltipInstances.length; i += 1) {
        if (bpTest() && $display.hasClass('force-grid')) {
          tooltipInstances[i].enable();
        } else {
          tooltipInstances[i].disable();
        }
      }
    };
    disableTooltips();

    /**
     * Toggle handler.
     */
    $toggle.on('click', (e) => {
      if (e.target.checked === true) {
        $display.addClass('force-grid');
        $display.removeClass('force-list');
      } else {
        $display.removeClass('force-grid');
        $display.addClass('force-list');
      }
      disableTooltips();
    });

    /**
     * Reset grid on resize.
     */
    $(window).on('resize', () => {
      if (bpTest()) {
        $('.tracking-grid-toggle__switch input').prop('checked', true);
        $display.addClass('force-grid');
        $display.removeClass('force-list');
      } else {
        $('.tracking-grid-toggle__switch input').prop('checked', false);
        $display.removeClass('force-grid');
        $display.addClass('force-list');
      }
      disableTooltips();
    });
  });
};

// On ready.
$(trackerGrid());
